import { PlanTier } from '@/data/plans';

export type CheckoutTier = Exclude<PlanTier, 'Enterprise'>;

const STORAGE_KEY = 'eezi.pendingPlanTier';

const isCheckoutTier = (value: unknown): value is CheckoutTier => value === 'Lite' || value === 'Plus';

// sessionStorage survives the sign-up redirects (and org creation) within the tab,
// unlike a query param that gets dropped on the first router.push
export const setPendingPlanTier = (tier: CheckoutTier): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, tier);
  } catch {
    // storage unavailable (SSR / privacy mode) — flow degrades to manual plan selection
  }
};

export const peekPendingPlanTier = (): CheckoutTier | null => {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    return isCheckoutTier(value) ? value : null;
  } catch {
    return null;
  }
};

export const consumePendingPlanTier = (): CheckoutTier | null => {
  const tier = peekPendingPlanTier();
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  return tier;
};
